import { DosageRequest } from "api/types"

export const medecinTypeOptions = [
  {
    value: DosageRequest.DrugsTypeEnum.EYEDROPS,
    label: "Collyr",
  },
  {
    value: DosageRequest.DrugsTypeEnum.TABLETS,
    label: "Comprimé"
  },
  {
    value: DosageRequest.DrugsTypeEnum.SYRUP,
    label: "Sirop"
  },
  {
    value: DosageRequest.DrugsTypeEnum.CREAM,
    label: "Pommade"
  },
  {
    value: DosageRequest.DrugsTypeEnum.CAPSULES,
    label: "Gélule"
  },

]

export const timeOfDayOptions = [
  {
    value: "Matin, Midi et Soir",
    label: "Matin, Midi et Soir",
  },
  {
    value: "Matin et Soir",
    label: "Matin et Soir",
  },
  {
    value: "Midi et Soir",
    label: "Midi et Soir",
  },
  {
    value: "Matin et Midi",
    label: "Matin et Midi",
  },
  {
    value: "Matin",
    label: "Matin",
  },
  {
    value: "Midi",
    label: "Midi",
  },
  {
    value: "Soir",
    label: "Soir",
  },
]

export const dureeOptions = [
  {
    value: 1,
    label: 1
  },
  {
    value: 2,
    label: 2
  },
  {
    value: 3,
    label: 3
  },
  {
    value: 4,
    label: 4
  },
  {
    value: 5,
    label: 5
  }
]
